/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/businesses/businessesActions";
import { useBusinessesUIContext } from "../BusinessesUIContext";

export function BusinessesDeleteDialog({ show, onHide }) {
  // Businesses UI Context
  const businessesUIContext = useBusinessesUIContext();
  const businessesUIProps = useMemo(() => {
    return {
      ids: businessesUIContext.ids,
      setIds: businessesUIContext.setIds,
      queryParams: businessesUIContext.queryParams,
    };
  }, [businessesUIContext]);

  // Businesses Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.businesses.actionsLoading }),
    shallowEqual
  );

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  // if there weren't selected businesses we should close modal
  useEffect(() => {
    if (!businessesUIProps.ids || businessesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessesUIProps.ids]);

  const deleteBusinesses = () => {
    // server request for deleting business by seleted ids
    dispatch(actions.deleteBusinesses(businessesUIProps.ids)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchBusinesses(businessesUIProps.queryParams)).then(() => {
        // clear selections list
        businessesUIProps.setIds([]);
        // closing delete modal
        onHide();
      });
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Businesses Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete selected businesses?</span>
        )}
        {isLoading && <span>Businesses are deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteBusinesses}
            className="btn btn-primary btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
